<div>
    <mat-card appearance="outlined" class="banner">
        <span>
            For assistance with creating and running reports, check our <a routerLink="/knowledge-base">Knowledge Base</a>
            or contact "MSSPDev@lumen.com"
        </span>
    </mat-card>
</div>
